<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">{{ $t('agents.agentsLabel') }}</span>
        <h3 class="page-title">{{ $t('agents.addNewAgent') }}</h3>
      </d-col>
      <d-col col sm="6" class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button
          theme="secondary"
          @click.prevent="$router.push('/agenci')"
          class="mr-1">
          <i class="material-icons">arrow_back</i>
          {{ $t('ui.backToList') }}
        </d-button>

        <d-button theme="success" @click.prevent="validateForm">
          <i class="material-icons">add</i>
          {{ $t('agents.addAgent') }}
        </d-button>
      </d-col>
    </d-row>

    <!-- Form -->
    <d-form>
      <d-card class="mb-5">
        <d-tabs card>
          <!-- Dane ogólne -->
          <d-tab
            :title="$t('ui.generalInfo')"
            active>
            <h4 class="mb-3 pb-3 border-bottom">
              {{ $t('ui.generalInfo') }}
            </h4>

            <validation-observer ref="agent-new-form" tag="form">
              <div class="form-group">
                <label for="name">
                  {{ $t('ui.name') }}:
                </label>

                <validation-provider
                  rules="required"
                  name="name"
                  v-slot="{ errors }">
                  <d-input
                    :state="errors.length ? 'invalid' : null"
                    v-model="name" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>

              <div class="form-group">
                <label for="name">
                  {{ $t('agents.commission') }}:
                </label>

                <validation-provider
                  rules="required|min_value:0|max_value:100"
                  name="commission"
                  v-slot="{ errors }">
                  <d-input
                    :state="errors.length ? 'invalid' : null"
                    :min="0"
                    :step="0.01"
                    :max="100"
                    v-model="commission" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>

              <d-row>
                <d-col cols="2">
                  <div class="form-group">
                    <label>
                      {{ $t('agents.sendReport') }}:
                    </label>

                    <div>
                      <d-checkbox
                        inline
                        v-model="sendReport"
                        toggle
                        toggle-small />
                    </div>
                  </div>
                </d-col>
                <d-col
                  v-if="sendReport"
                  cols="10">
                  <div class="form-group">
                    <label>
                      {{ $t('agents.reportEmail') }}:
                    </label>

                    <validation-provider
                      rules="email"
                      name="email"
                      v-slot="{ errors }">
                      <d-input
                        :state="errors.length ? 'invalid' : null"
                        type="email"
                        v-model="reportEmail"
                        :readonly="!sendReport" />
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>
              </d-row>
            </validation-observer>
          </d-tab>

          <d-tab
            :title="$t('agents.assignedCustomers')">
            <h4 class="mb-3 pb-3 border-bottom">
              {{ $t('agents.assignedCustomers') }}
            </h4>

            <d-alert
              show
              theme="warning">
              {{ $t('agents.thisTabWillBeAvailableAfterSavingAgent') }}
            </d-alert>
          </d-tab>

          <d-tab
            :title="$t('agents.commissionsList')">
            <h4 class="mb-3 pb-3 border-bottom">
              {{ $t('agents.commissionsList') }}
            </h4>

            <d-alert
              show
              theme="warning">
              {{ $t('agents.thisTabWillBeAvailableAfterSavingAgent') }}
            </d-alert>
          </d-tab>

          <d-tab
            :title="$t('agents.settlementsHistory')">
            <h4 class="mb-3 pb-3 border-bottom">
              {{ $t('agents.settlementsHistory') }}
            </h4>

            <d-alert
              show
              theme="warning">
              {{ $t('agents.thisTabWillBeAvailableAfterSavingAgent') }}
            </d-alert>
          </d-tab>
        </d-tabs>
      </d-card>
    </d-form>
  </d-container>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';

export default {
  name: 'agent-new',
  data() {
    return {
      name: '',
      commission: '',
      sendReport: false,
      reportEmail: ''
    };
  },
  methods: {
    validateForm () {
      FormUtils.validate(this.$refs['agent-new-form'], this.submitForm);
    },
    submitForm () {
      let dataToSend = {
        name: this.name,
        commission: this.commission,
        send_report: +this.sendReport
      };

      if (this.sendReport) {
        dataToSend.report_email = this.reportEmail;
      }

      FormUtils.submit({
        $http: this.$http,
        endpoint: '/agents/store',
        formData: dataToSend,
        successTitle: this.$t('agents.addAgentSuccessTitle'),
        successText: this.$t('agents.addAgentSuccessText'),
        errorTitle: this.$t('ui.errorOccured'),
        errorText: this.$t('agents.addAgentErrorText'),
        successAction: () => {
          this.$router.push('/agenci')
        }
      });
    }
  }
};
</script>
